import script from "./NotificationSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationSnackbar.vue?vue&type=script&setup=true&lang=ts"

import "./NotificationSnackbar.vue?vue&type=style&index=0&id=51365c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51365c50"]])

export default __exports__